import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BotUsuario } from '../models/BotUsuario';

const httpOptions = {

  headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};

@Injectable({
  providedIn: 'root'
})
export class BackEndBotService {

  private urlBotIptApi = environment.urlBackEndBotTelegram;

  constructor(private http: HttpClient) { }

  // Interacción con backend - UsuarioController

  obtenerUsuarios(): Observable<BotUsuario[]> {
    return this.http.get<BotUsuario[]>(`${this.urlBotIptApi}/usuario`);
  }

  borrarUsuario(usuario: BotUsuario): any {
    return this.http.delete<BotUsuario>(`${this.urlBotIptApi}/usuario/${usuario.id}`, httpOptions).pipe(
    );
  }

  agregarUsuario(usuario: BotUsuario){
    return this.http.post(`${this.urlBotIptApi}/usuario`,usuario,httpOptions);
  }

  editarUsuario(usuario: BotUsuario){
    return this.http.put(`${this.urlBotIptApi}/usuario`,usuario,httpOptions);
  }

  buscarUsuario(id: String): Observable<BotUsuario> {
    return this.http.get<BotUsuario>(`${this.urlBotIptApi}/usuario/${id}`);
  }
}
